<template>
  <div class="allBox">
    <div class="allBoxTitle">
      <h3 class="allTitle">{{$t('DakaNews')}}</h3>
      <router-link :to="{path:'/info'}">{{$t('ViewMore')}}</router-link>
    </div>
    <ul class="hotinformation" v-if="list!=null">
      <li v-for='(item,index) in list' :key='index'>
        <router-link :to="{path:'/info/item/'+item._id+'?i='+index+'&p='+pi}">
          <div class="hotinformationimg"><img :src="item.ImgUrl+'?imageView2/2/h/360'"></div>
          <div class="hotinformationText">
            <p class="line_txt1">{{item.Title}}</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'hotinformation',
  data() {
    return {
      pi:1,
      ps:3,
      loading: false,
      list: null
    }
  },
  mounted() {},
  created() {
    this.getRealtime()
  },
  methods: {
    getRealtime(){
      let that=this;
      let data={PageIndex:that.pi,PageSize:that.ps}
      that.$get(that.$interface.Realtime,data).then(res=>{
        if(res.Result!=0){
          that.list=res.Data
        }
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/home.css";

</style>



// WEBPACK FOOTER //
// src/pages/home/hotinformation.vue